var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "outside-click-listener",
    {
      staticClass: "relative",
      on: {
        clickoutside: function ($event) {
          _vm.isOpened = false
        },
      },
    },
    [
      _c("search-form-input", {
        staticClass: "cursor-text",
        attrs: {
          label: _vm.label,
          name: _vm.name,
          value: _vm.isOpened ? _vm.userInput : _vm.value,
          isOpened: _vm.isOpened,
        },
        on: {
          input: _vm.handleInput,
          openstatechange: _vm.handleOpenStateChange,
        },
      }),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass:
            "absolute top-1/2 -translate-y-1/2 right-4 lg:right-6 pointer-events-none",
          attrs: {
            width: "25",
            height: "24",
            viewBox: "0 0 25 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M7.25 9.375L12.5 14.625L17.75 9.375",
              stroke: "currentcolor",
              "stroke-width": "1.5",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.value.length
        ? _c("close-button", { on: { click: _vm.handleClearClick } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpened,
              expression: "isOpened",
            },
          ],
          staticClass:
            "search-form-dropdown font-[500] px-4 lg:px-2 2xl:px-4 py-2",
          class: { "lg:w-[30rem_!important]": _vm.slicedResults.length },
          staticStyle: { display: "none" },
        },
        [
          _vm.isLoading
            ? _c("p", {
                staticClass: "px-4 py-2 custom-label-tighter opacity-40",
                domProps: { textContent: _vm._s(_vm.t.loading) },
              })
            : _vm.slicedResults.length
            ? _c(
                "ul",
                _vm._l(_vm.slicedResults, function (item) {
                  return _c(
                    "li",
                    {
                      key: _vm.generateKey(item),
                      staticClass:
                        "custom-choice-option justify-between cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.handleItemClick(item)
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: { textContent: _vm._s(item.name) },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "opacity-40 custom-label-tighter",
                        domProps: { textContent: _vm._s(item.code) },
                      }),
                    ]
                  )
                }),
                0
              )
            : _vm.userInput
            ? _c("p", {
                staticClass: "px-4 py-2 custom-label-tighter opacity-40",
                domProps: { textContent: _vm._s(_vm.t.noResultsFound) },
              })
            : _c("p", {
                staticClass: "px-4 py-2 custom-label-tighter opacity-40",
                domProps: { textContent: _vm._s(_vm.t.startTyping) },
              }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }